function runSlider (selector, sliderFunction) {
    let slider = document.querySelector(selector)

    if (slider) {
        sliderFunction()
    } else {
        console.warn(`${selector} slider is not available`)
    }
}

export default runSlider